import { createAction } from 'redux-act';
import { getTasks, claimTasksReward } from '../../../api/tasks';

export const getTasksListLoading = createAction('Tasks list loading');
export const getTasksData = createAction('Tasks list loaded');
export const claimTasksRewardLoading = createAction('Claim tasks reward loading');

/** Nested daily/season payload from GET /home/tasks (see api-docs). */
export const normalizeTasksPayload = (payload) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return null;
  }
  const daily = payload.daily && typeof payload.daily === 'object' ? payload.daily : null;
  const season = payload.season && typeof payload.season === 'object' ? payload.season : null;
  if (!daily && !season) return null;
  return {
    daily: daily
      ? {
          tasks: Array.isArray(daily.tasks) ? daily.tasks : [],
          completed: Number(daily.completed) || 0,
          total: Number(daily.total) || 0,
          reward: Number(daily.reward) || 0,
          reward_claimed: Boolean(daily.reward_claimed),
        }
      : null,
    season: season
      ? {
          tasks: Array.isArray(season.tasks) ? season.tasks : [],
          completed: Number(season.completed) || 0,
          total: Number(season.total) || 0,
          reward: Number(season.reward) || 0,
          reward_claimed: Boolean(season.reward_claimed),
        }
      : null,
  };
};

export const getTasksList = () => async (dispatch) => {
  dispatch(getTasksListLoading(true));
  try {
    const response = await getTasks();
    if (response.status === 200) {
      const data = await response.json();
      dispatch(getTasksData(normalizeTasksPayload(data)));
    } else {
      dispatch(getTasksData(null));
    }
  } catch {
    dispatch(getTasksData(null));
  } finally {
    dispatch(getTasksListLoading(false));
  }
};

/** category: 0 = daily, 1 = season */
export const claimTasksRewardRequest = (category) => async (dispatch) => {
  dispatch(claimTasksRewardLoading(true));
  try {
    const response = await claimTasksReward(category);
    if (response.status === 200) {
      await dispatch(getTasksList());
      return true;
    }
    return false;
  } catch {
    return false;
  } finally {
    dispatch(claimTasksRewardLoading(false));
  }
};
